<script setup>
import { ref } from 'vue'

const props = defineProps({
    modelValue: { type: Boolean, default: true },
    type: { type: String, default: 'warning' },
    title: String,
    text: String,
    buttonText: { type: String, default: 'Recolher' },
    showButton: { type: Boolean, default: true }
})

const isCollapsed = ref(false)

const toggle = () => {
    isCollapsed.value = !isCollapsed.value
}
</script>

<template>
    <v-alert
        v-if="modelValue"
        :type="type"
        variant="tonal"
        border="start"
        class="custom-alert pe-12"
        :class="{ 'is-collapsed': isCollapsed }"
    >
        <template v-slot:prepend>
            <v-icon
                class="cursor-pointer"
                @click="toggle"
            >
                $info
            </v-icon>
        </template>

        <div >
            <v-row>
                <v-col md="12" sm="12" lg="9">
                    <div class="alert-content text-wrap">
                        <div v-if="title" class="alert-title">{{ title }}</div>
                        <div v-if="text" class="alert-text">{{ text }}</div>
                        <slot />
                    </div>
                </v-col>
                <v-col class="alert-col-button" md="12" sm="12" lg="3" cols="12">
                    <v-btn
                        v-if="showButton"
                        @click="toggle"
                        class="btn alert-btn"
                    >
                        {{ buttonText }}
                    </v-btn>
                </v-col>
            </v-row>
        </div>
    </v-alert>
</template>

<style scoped>
.custom-alert {
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    border-radius: 12px;
    transition:
        width 0.45s cubic-bezier(0.4, 0, 0.2, 1),
        min-width 0.45s cubic-bezier(0.4, 0, 0.2, 1),
        padding 0.3s ease;
}

.custom-alert.is-collapsed {
    width: 56px;
    min-width: 56px;
    height: 56px;
    padding-inline-end: 0;
    cursor: pointer;
}

.alert-col-button {
    display: flex;
    justify-content: center;
    align-content: space-around;
    flex-wrap: wrap;
}

.custom-alert.is-collapsed .alert-inner-wrapper {
    opacity: 0;
    transform: translateX(-10px);
    pointer-events: none;
}

.alert-content {
    display: flex;
    flex-direction: column;
}

.alert-title {
    font-weight: 600;
    font-size: 14px;
}

.alert-text {
    font-size: 13px;
    opacity: 0.9;
}

.alert-btn {
    background-color: #fb8c0021;
    border-radius: 8px;
    text-transform: none;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
